import { Skeleton, Stack } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useGetTourDescriptionByIdQuery } from 'Services/institution'
import { Avatar } from './'

interface TourGuideProps {
  descriptionId: number
  language: string
}

const TourGuide = ({ descriptionId, language }: TourGuideProps) => {
  const { locId, instId } = useSelector((state: any) => state.location)
  const selectedLanguage = useSelector((state: any) => state.language)

  const {
    data: tourDescription,
    isSuccess: tourDescriptionSuccess,
    isLoading,
  } = useGetTourDescriptionByIdQuery(
    {
      instId,
      locId,
      descriptionId,
      language,
    },
    { skip: !locId || !instId }
  )

  if (selectedLanguage == language) {
    if (isLoading && !tourDescriptionSuccess)
      return (
        <>
          <Skeleton
            width={200}
            animation='wave'
            variant='text'
            sx={{ fontSize: '16px' }}
          />
          <Skeleton
            width={300}
            animation='wave'
            height={54}
            variant='rounded'
          />
        </>
      )
    else if (tourDescriptionSuccess) {
      const youVisitAssetUrl =
        tourDescription?.resources?.metadata?.path?.videoAvatar.slice(
          0,
          tourDescription?.resources?.metadata?.path?.videoAvatar.indexOf(
            '/media'
          )
        )
      const avatar = tourDescription?.resources?.description?.avatar
      const videoAvatar = tourDescription?.resources?.description?.video_avatar
      const avatarVideoUrl = `${youVisitAssetUrl}/media/${locId}/avatars/${avatar}.mp4`
      const avatarAudioUrl = tourDescription?.resources?.description.audio_url

      return (
        <Stack alignItems={'center'} data-testid='audio-guide'>
          <h4>Tour Stop Audio Transcript</h4>
          {videoAvatar ? 
            <Avatar videoUrl={avatarVideoUrl} />
            :
            avatarAudioUrl && <audio controls>
              <source
                src={avatarAudioUrl}
                type='audio/mp3'
              />
              Your browser does not support the audio element.
            </audio>
          }
          <p
            tabIndex={0}
            aria-label={tourDescription?.resources?.description?.description}
          >
            {tourDescription?.resources?.description?.description}
          </p>
        </Stack>
      )
    }
  }
  return null
}

TourGuide.defaultProps = {
  title: 'Tour Stop Audio Transcript',
}

export default TourGuide
